var exports = {
  "Zd": "EmbedDebuggerTab.module__form___ak5nTz",
  "v1": "EmbedDebuggerTab.module__formControls___ak5nTz",
  "Wn": "EmbedDebuggerTab.module__urlField___ak5nTz",
  "Y2": "EmbedDebuggerTab.module__urlInput___ak5nTz",
  "RC": "EmbedDebuggerTab.module__submitButton___ak5nTz",
  "Xv": "EmbedDebuggerTab.module__results___ak5nTz",
  "KR": "EmbedDebuggerTab.module__embedPreview___ak5nTz",
  "Dy": "EmbedDebuggerTab.module__codeSurface___ak5nTz",
  "qS": "EmbedDebuggerTab.module__statusText___ak5nTz",
  "kc": "EmbedDebuggerTab.module__errorText___ak5nTz",
};

module.exports = exports;
